import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query';
import { useGetInvoiceByIdQuery, useGetInvoiceRestrictedInfoQuery } from 'store/api/invoices';
import { InvoiceData } from 'types/invoices';

interface UseInvoiceWithRestrictedReturn {
    data: InvoiceData | undefined;
    refetch: () => void;
    isLoading: boolean;
    isFetching: boolean;
    error: FetchBaseQueryError | SerializedError | undefined;
}

export const useInvoiceWithRestricted = (invoiceId?: string): UseInvoiceWithRestrictedReturn => {
    const {
        data: invoiceData,
        refetch: refetchInvoice,
        isLoading: isInvoiceLoading,
        isFetching: isInvoiceFetching,
        error: invoiceError,
    } = useGetInvoiceByIdQuery(invoiceId ?? skipToken);

    const shouldGetRestricted = invoiceError && 'status' in invoiceError && invoiceError.status === 403;

    const {
        data: restrictedData,
        isLoading: isRestrictedLoading,
        isFetching: isRestrictedFetching,
        error: restrictedError,
    } = useGetInvoiceRestrictedInfoQuery(invoiceId ?? skipToken, {
        skip: !shouldGetRestricted,
    });

    return {
        data: shouldGetRestricted ? restrictedData : invoiceData,
        refetch: () => {
            void refetchInvoice();
        },
        isLoading: isInvoiceLoading || (shouldGetRestricted ? isRestrictedLoading : false),
        isFetching: isInvoiceFetching || (shouldGetRestricted ? isRestrictedFetching : false),
        error: shouldGetRestricted ? restrictedError : invoiceError,
    };
};
